export default __webpack_public_path__ + "static/media/decreaseFS.14eadd0d.svg";